export interface PlumbingWorkItem {
  Item: string;
  Quantity: number;
  check: boolean;
  FieldType?: string;
}

export interface GetAllFee {
  'Plumbing Size': number;
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface PlumbingData {
  WorkItems: PlumbingWorkItem[];
  PlumbingCharacteristics: any;
  getAllFee: GetAllFee;
}

export const plumbingData: PlumbingData = {
  PlumbingCharacteristics: {},
  WorkItems: [
    { Item: "Water Closet", Quantity: 1, check: false },
    { Item: "Urinal Bidet", Quantity: 1, check: false },
    { Item: "Bathtub", Quantity: 1, check: false },
    { Item: "Lavatory", Quantity: 1, check: false },
    { Item: "Shower", Quantity: 1, check: false },
    { Item: "Floor Drain", Quantity: 1, check: false },
    { Item: "Sink", Quantity: 1, check: false },
    { Item: "Dishwasher", Quantity: 1, check: false },
    { Item: "Drink Fountain", Quantity: 1, check: false },
    { Item: "Washing Machine", Quantity: 1, check: false },
    { Item: "Hose Bib", Quantity: 1, check: false },
    { Item: "Gas Piping", Quantity: 1, check: false },
    { Item: "Fuel Oil Piping", Quantity: 1, check: false },
    { Item: "Steam Boiler", Quantity: 1, check: false },
    { Item: "Hot Water Boiler", Quantity: 1, check: false },
    { Item: "Water Heater", Quantity: 1, check: false },
    { Item: "Sewer Pumps", Quantity: 1, check: false, FieldType: 'Select' },
    { Item: "Interceptor", Quantity: 1, check: false, FieldType: 'Select' },
    { Item: "Commercial Backflow", Quantity: 1, check: false },
    { Item: "Water Cooled", Quantity: 1, check: false, FieldType: 'Select' },
    { Item: "Sewer Connection", Quantity: 1, check: false },
    { Item: "Water Service", Quantity: 1, check: false },
    { Item: "Active Solar System", Quantity: 1, check: false },
    { Item: "Vents Stacks", Quantity: 1, check: false },
    { Item: "Lawn Sprinkler System", Quantity: 1, check: false },
    { Item: "Water Filter Cond System", Quantity: 1, check: false },
    { Item: "Sump Pump", Quantity: 1, check: false },
    { Item: "Roof Drains", Quantity: 1, check: false },
    { Item: "Condensate Drain", Quantity: 1, check: false },
    { Item: "Medical Gas System", Quantity: 1, check: false },
    { Item: "Pressure Booster", Quantity: 1, check: false },
    { Item: "Pool Heater", Quantity: 1, check: false },
    { Item: "Commercial RTU", Quantity: 1, check: false },
    { Item: "Pool Piping", Quantity: 1, check: false },
    { Item: "Commercial HVAC Hydronic Piping", Quantity: 1, check: false },
    { Item: "Residential HVAC Hydronic Piping", Quantity: 1, check: false },
    { Item: "Commercial Roof Drain Leaders", Quantity: 1, check: false },
    { Item: "New Furnace Install", Quantity: 1, check: false },
    { Item: "Residential Backflow", Quantity: 1, check: false }

  ],
  getAllFee: {
    'Plumbing Size': 0,
    'Certification Cost': 0,
    totalFee: 0,
    summary: []
  }
}
